import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { User } from 'frontend-utils/models';
import type MarketSettingsHotelsRoute from 'lumen/routes/market/settings/hotels';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsHotelsController extends Controller {
  declare model: ModelFrom<MarketSettingsHotelsRoute>;

  queryParams = ['user', 'hotelId', 'marketId', 'page', 'refresh'];

  @service declare intl: Services['intl'];

  @tracked page = 1;

  hotelId = null;
  isAddUserToHotelDialogVisible = false;
  marketId = null;
  refresh = false;
  selectedHotelOrMarket = null;
  selectedUser = null;
  user = null;

  @action closeAddUserToHotelModal(): void {
    set(this, 'isAddUserToHotelDialogVisible', false);
  }

  @action doRefresh(removedUser: unknown): void {
    if (removedUser) {
      set(this, 'user', null);
      set(this, 'selectedUser', {
        email: this.intl.t('settings.all_users_filter'),
      });
    }
    this.send('refreshRoute');
  }

  @action selectHotelOrMarket(hotelOrMarket: {
    hotel_id?: string;
    market_id?: string;
  }): void {
    if (hotelOrMarket.hotel_id) {
      set(this, 'marketId', null);
      set(this, 'hotelId', hotelOrMarket.hotel_id);
    } else if (hotelOrMarket.market_id) {
      set(this, 'hotelId', null);
      set(this, 'marketId', hotelOrMarket.market_id);
    } else {
      set(this, 'hotelId', null);
      set(this, 'marketId', null);
    }
    set(this, 'page', 1);
    set(this, 'selectedHotelOrMarket', hotelOrMarket);
  }

  @action selectUser(user: User): void {
    if (user.id) {
      set(this, 'user', user.id);
    } else {
      set(this, 'user', null);
    }
    set(this, 'page', 1);
    set(this, 'selectedUser', user);
  }

  @action setPage(page: number): void {
    this.page = page;
  }

  @action showAddUserToHotelModal(): void {
    set(this, 'isAddUserToHotelDialogVisible', true);
  }
}
